import { faAngleDoubleDown, faAngleDoubleRight, faCaretDown, faCaretRight, faCheck, faCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap'

export const formatShaThumbprintColumn = (cell: any) => {
  if (cell === undefined) {
    return ''
  }
  return (
    <span className='thumbprint'>
      {cell.match(/(.{1,2})/g).map((data: any) => (
        <span>{data}</span>
      ))}
    </span>
  )
}

export const formatBooleanColumn = (cell: any) => {
  return cell !== undefined && JSON.parse(cell.toString().toLowerCase()) ? <FontAwesomeIcon icon={faCheck} className='text-primary' /> : ''
}

export const formatProxyStatusColumn = (cell: any, row: any) => {
  switch (cell) {
    case 'RUNNING':
      return (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id='button-tooltip'>Running</Tooltip>}>
          <FontAwesomeIcon icon={faCircle} className='text-primary' />
        </OverlayTrigger>
      )

    case 'STOPPED':
      return (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id='button-tooltip'>Stopped</Tooltip>}>
          <FontAwesomeIcon icon={faCircle} className='text-danger' />
        </OverlayTrigger>
      )

    case 'CORRUPTED':
      return (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id='button-tooltip'>Corrupted - {row.corruptedMessage}</Tooltip>}>
          <FontAwesomeIcon icon={faExclamationTriangle} className='text-warning' />
        </OverlayTrigger>
      )

    case 'DELETED':
      return (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id='button-tooltip'>Deleted</Tooltip>}>
          <FontAwesomeIcon icon={faCircle} className='text-muted' />
        </OverlayTrigger>
      )

    case 'MODIFIED':
      return (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id='button-tooltip'>Modified</Tooltip>}>
          <FontAwesomeIcon icon={faCircle} className='text-warning' />
        </OverlayTrigger>
      )

    default:
      return ''
  }
}

export const expandRowFunction = (renderer: any, nonExpandable: any, ...args: any[]) => {
  return {
    renderer: (row: any, rowIndex: any) => renderer(row, rowIndex, ...args),
    showExpandColumn: true,
    expandByColumnOnly: true,
    parentClassName: 'border border-bottom-0 border-primary',
    className: 'border border-top-0 border-primary',
    nonExpandable: nonExpandable(),
    expandHeaderColumnRenderer: ({ isAnyExpands }: any) => {
      if (isAnyExpands) {
        return <FontAwesomeIcon icon={faAngleDoubleDown} />
      }
      return <FontAwesomeIcon icon={faAngleDoubleRight} />
    },
    expandColumnRenderer: ({ expanded, rowKey, expandable }: any) => {
      if (!expandable) {
        return <></>
      }

      return <FontAwesomeIcon icon={expanded ? faCaretDown : faCaretRight} />
    },
  }
}

export const formatMssqlPloicyStatus = (cell: any) => {
  return (
    <Badge pill variant={getMssqlPloicyStatusVariant(cell)} className='rounded-pill'>
      {cell}
    </Badge>
  )
}

function getMssqlPloicyStatusVariant(cell: any) {
  switch (cell) {
    case 'APPLIED':
      return 'primary'
    case 'INCOMPLETE':
      return 'danger'
    case 'MISSING':
      return 'warning'
    case 'REMOVED ':
      return 'warning'
    default:
      return 'secondary'
  }
}
